import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function emphasiseText(text) {
    const parts = text.split('##');
    return _jsx(_Fragment, { children: parts.map((part, index) => (index % 2 === 1 ? _jsx("em", { children: part }, index) : part)) });
}
